import React                  from 'react';
import PropTypes              from 'prop-types';
import {VXButtonLineConfig}   from '../../SimpleElements/VXButton/VXButtonConfig';
import VXButtonOutline        from '../../SimpleElements/VXButton/Presets/VXButtonOutline';
import UrlBuilder             from '../../../utils/UrlBuilder';
import {getCommonTranslation} from '../../../utils/TranslationHelper';
import Translations           from '../../../utils/Translations';
import Flux                   from '../../../flux/Flux';
import SlickSlider            from "../../VXMobile/SlickSlider/SlickSlider";
import FeedBlockSliderTile    from './FeedBlockSliderTile';
import ReloadHelper           from '../../../utils/ReloadHelper';
import {generateKey}          from '../../../utils/CommonUtils';

const BP = {
    lg: Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.lg,
    md: Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md,
    sm: Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm,
    xs: Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm,
};

const SLIDES = {
    [BP.lg]: {
        show:   4,
        scroll: 4
    },
    [BP.md]: {
        show:   2.5,
        scroll: 2
    },
    [BP.sm]: {
        show:   1.5,
        scroll: 1
    },
    [BP.xs]: {
        show:   1.25,
        scroll: 1
    },
    xl:      {
        show:   4.5,
        scroll: 4
    }
};

class FeedBlock extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data:     [],
            isMobile: window.innerWidth < BP.md || this.props.isMobile,
        };

        this.onWindowResize    = this.onWindowResize.bind(this);
        this.onClickModel      = this.onClickModel.bind(this);
        this.onVideoEnd        = this.onVideoEnd.bind(this);
        this.afterSliderChange = this.afterSliderChange.bind(this);

        this.sliderRef;
        this.blockRef;
        this.hasInitPlayed = false;
        this.observer      = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.hasInitPlayed) {
                this.hasInitPlayed = true;
                this.initPlayVideo();
            } else {
                Flux.Feed.toggleBlockVideoPlay("");
            }
        }, {rootMargin: "20%"});
    }

    componentDidMount() {
        this.loadPosts();
        Flux.Browser.addWindowResizeListener(this.onWindowResize);
        if (this.blockRef) {
            setTimeout(() => {
                this.observer.observe(this.blockRef);
            }, 2500);
        }
    }

    componentWillUnmount() {
        Flux.Browser.removeWindowResizeListener(this.onWindowResize);
    }

    onWindowResize() {
        this.setState({isMobile: window.innerWidth < BP.md || this.props.isMobile});
    }

    loadPosts() {
        const queryString = window.location.search;
        const urlParams   = new URLSearchParams(queryString);
        const onlyVideo   = urlParams.get('onlyFeedBlockVideo');
        const typeGroups  = [];
        if (onlyVideo) {
            typeGroups.push("CLIP_POSTS");
        } else {
            typeGroups.push("CLIP_POSTS");
            typeGroups.push("PHOTOS_POSTS");
        }

        Flux.Feed.getFeedData({mode: Flux.Constants.Feed.Mode.STARTPAGE, first: 11, typeGroups}, (res) => {
            const data = res.data.feed.posts.edges;
            this.setState({data});
        });
    }

    onClick(e) {
        e.preventDefault();
        ReloadHelper.reload(UrlBuilder.buildFeedRoute());
    }

    onClickModel(url) {
        ReloadHelper.reload(url);
    }

    getLastTile() {
        return (
                <div key={generateKey("last-tile")} className='slick-slide'>
                    <div className='feed-block__slider-tile-wrapper'>
                        <div onClick={this.onClick} className='feed-block__slider-tile feed-block__slider-tile--last'>
                            <div className='feed-block__slider-tile__last-text'>{getCommonTranslation('feed-block-last-1')}</div>
                            <div className='feed-block__slider-tile__last-text feed-block__slider-tile__last-text--red'>{getCommonTranslation('feed-block-last-2')}</div>
                            <div className='feed-block__slider-tile__last-text'>{getCommonTranslation('feed-block-last-3')}</div>
                            <div className='feed-block__slider-tile__last-subline'>{getCommonTranslation('feed-block-last-subline')}</div>
                            <div className='feed-block__slider-tile__last-link'>{getCommonTranslation('feed-block-last-link')}
                                <i className='icon -icon-double-arrow-right-line'></i></div>
                        </div>
                    </div>
                </div>
        );
    }

    setBlockRef(ref) {
        if (ref) {
            this.blockRef = ref;
            if (typeof this.props.parentCallback === 'function') {
                this.props.parentCallback(ref);
            }
        }
    }

    setSliderRef(ref) {
        if (ref) {
            this.sliderRef = ref;
        }
    }

    getSlides() {
        const width = window.innerWidth;

        if (width > BP.lg) {
            return SLIDES.xl.scroll;
        } else if (width > BP.md) {
            return SLIDES[BP.lg].scroll;
        } else if (width > BP.sm) {
            return SLIDES[BP.md].scroll;
        } else if (width > BP.xs) {
            return SLIDES[BP.sm].scroll;
        } else {
            return SLIDES[BP.xs].scroll;
        }
    }

    getCurrentVideoIds() {
        const data          = [...this.state.data];
        const currentSlide  = this.sliderRef.slider.innerSlider.state.currentSlide;
        const slides        = this.getSlides();
        const currentSlides = data.slice(currentSlide, (currentSlide + slides));
        return currentSlides.filter(item => !!item.node.clip).map(item => item.node.id);
    }

    initPlayVideo() {
        const videoIds = this.getCurrentVideoIds();
        if (videoIds.length > 0) {
            Flux.Feed.toggleBlockVideoPlay(videoIds[0]);
        }
    }

    onVideoEnd(id) {
        const videoIds     = this.getCurrentVideoIds();
        const currentIndex = videoIds.indexOf(id);
        const nextVideoId  = videoIds[(currentIndex + 1)] || "";

        if (currentIndex > -1 && nextVideoId) {
            Flux.Feed.toggleBlockVideoPlay(nextVideoId);
        } else {
            Flux.Feed.toggleBlockVideoPlay("");
        }
    }

    afterSliderChange(currentSlide) {
        if (currentSlide >= 0 && this.state.data[currentSlide] && this.state.data[currentSlide].node.clip) {
            Flux.Feed.toggleBlockVideoPlay(this.state.data[currentSlide].node.id);
        }
    }

    getSlider() {
        if (this.state.data.length < 1) {
            return null;
        }

        const tiles = this.state.data.map((tile, index) =>
                <div
                        key={generateKey(tile.node.model.name, index)}
                        className='slick-slide'
                >
                    <FeedBlockSliderTile key={generateKey("feed-" + tile.node.model.name, index)}
                                         tile={tile.node}
                                         isMobile={this.state.isMobile}
                                         onClickModel={this.onClickModel}
                                         sliderRef={this.sliderRef}
                                         onVideoEnd={this.onVideoEnd} />
                </div>
        );
        tiles.push(this.getLastTile());

        const sliderConfig = {
            speed:          300,
            initialSlide:   1,
            slidesPerRow:   1,
            slidesToShow:   4.5,
            slidesToScroll: 4,
            arrows:         true,
            dots:           false,
            infinite:       false,
            variableWidth:  false,
            draggable:      true,
            useTransform:   false,
            touchThreshold: 150,
            responsive:     [
                {
                    breakpoint: BP.lg,
                    settings:   {
                        draggable:      true,
                        arrows:         true,
                        slidesToShow:   SLIDES[BP.lg].show,
                        slidesToScroll: SLIDES[BP.lg].scroll,
                        speed:          300,
                    }
                },
                {
                    breakpoint: BP.md,
                    settings:   {
                        slidesToShow:   SLIDES[BP.md].show,
                        slidesToScroll: SLIDES[BP.md].scroll,
                        draggable:      true,
                        arrows:         true,
                        speed:          300,
                    }
                },
                {
                    breakpoint: BP.sm,
                    settings:   {
                        slidesToShow:   SLIDES[BP.sm].show,
                        slidesToScroll: SLIDES[BP.sm].scroll,
                        arrows:         false,
                        draggable:      true,
                        speed:          300
                    }
                },
                {
                    breakpoint: BP.xs,
                    settings:   {
                        slidesToShow:   SLIDES[BP.xs].show,
                        slidesToScroll: SLIDES[BP.xs].scroll,
                        arrows:         false,
                        draggable:      true,
                        centerMode:     true,
                        speed:          300
                    }
                }
            ]
        };

        return (
                <div className='feed-block__slider-wrapper'>
                    <div className='feed-block__slider'>
                        <div className={"ui-slider"}>
                            <SlickSlider ref={ref => this.setSliderRef(ref)} afterChange={this.afterSliderChange} {...sliderConfig}>
                                {tiles}
                            </SlickSlider>
                        </div>
                    </div>
                </div>
        );
    }

    render() {
        const {as: Tag} = this.props;

        return (
                <Tag
                        className={'feed-block' + (this.state.isMobile ? " feed-block--mobile" : " feed-block--desktop")}
                        id='feed-block'
                        ref={(ref) => this.setBlockRef(ref)}
                >
                    <div className='feed-block__headline'>
                        <span className='badge--highlight feed-block__badge'>{Translations.get('BadgeNew')}</span>
                        <h2>
                            {getCommonTranslation('explore')}
                        </h2>
                    </div>
                    <div className='feed-block__subline'>/ {getCommonTranslation('feed-block-subline')}</div>
                    <div className='feed-block__button'>
                        <VXButtonOutline line1={[new VXButtonLineConfig(getCommonTranslation('all-contributions'))]}
                                         link={UrlBuilder.buildFeedRoute()} />
                    </div>
                    {this.getSlider()}
                </Tag>
        );
    }
}

FeedBlock.propTypes = {
    as:             PropTypes.string,
    parentCallback: PropTypes.func,
    isMobile:       PropTypes.bool
};

FeedBlock.defaultProps = {
    as:       'div',
    isMobile: true,
};


export default FeedBlock;
